/**
 * Blueprint for the campaign entity.
 */
export class FanScore {
  public merchandiseOrdersThreshold?: number;
  public merchandiseRevenueThreshold?: number | string;
  public ticketingOrdersThreshold?: number;
  public ticketingRevenueThreshold?: number | string;
  public timeframeInMonths?: number;

  public constructor(fanScore?: any) {
    this.merchandiseOrdersThreshold = fanScore?.merchandiseOrdersThreshold;
    this.merchandiseRevenueThreshold = fanScore ? parseFloat((fanScore?.merchandiseRevenueThreshold / 100).toString()).toFixed(2) : null;
    this.ticketingOrdersThreshold = fanScore?.ticketingOrdersThreshold;
    this.ticketingRevenueThreshold = fanScore ? parseFloat((fanScore?.ticketingRevenueThreshold / 100).toString()).toFixed(2) : null;
    this.timeframeInMonths = fanScore?.timeframeInMonths;
  }
}
